import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useEffect, useState } from "react";
import "dayjs/locale/es-mx";

const FechaEjecucionModal = ({ open, onClose, onConfirm, asignacion }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [fechaInicio, setFechaInicio] = useState(dayjs());
  const [fechaFin, setFechaFin] = useState(dayjs());

  const handleClose = () => {
    onClose();
    setFechaInicio(dayjs());
    setFechaFin(dayjs());
  };

  const handleConfirm = () => {
    if (!fechaInicio || !fechaFin) {
      return;
    }
    if (fechaInicio.isSame(fechaFin) || fechaInicio.isAfter(fechaFin)) {
      setShowSnackbar(true);
      setSnackbarMessage(
        "La fecha de finalización debe ocurrir después de la fecha de inicio."
      );
      return;
    }
    onConfirm(fechaInicio.toISOString(), fechaFin.toISOString());
  };

  useEffect(() => {
    if (open) {
      if (asignacion.fechaEjecucion) {
        setFechaInicio(dayjs(asignacion.fechaEjecucion));
      }
      if (asignacion.fechaEjecucionFin) {
        setFechaFin(dayjs(asignacion.fechaEjecucionFin));
      }
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Establecer fecha de ejecución</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
          <DateTimePicker
            label="Fecha inicio"
            value={fechaInicio}
            onChange={(newValue) => setFechaInicio(newValue)}
            sx={{ margin: "10px 10px 0 0" }}
          />
          <DateTimePicker
            label="Fecha fin"
            value={fechaFin}
            onChange={(newValue) => setFechaFin(newValue)}
            sx={{ margin: "10px 0 0" }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default FechaEjecucionModal;
